import Vue from "vue";
import moment from "moment";
import users from "../users";
import axios from "axios";
import * as utils from "../utils";
import { propCheck } from "@/user/checkPropertyOriented";
import * as files from "../fileUtils";
import CookieLaw from "vue-cookie-law";
import * as VueGoogleMaps from "vue2-google-maps";

export default {
  name: "App",
  components: {
    AppMessagesComp: require("../user/applications/messages/messages.vue")
      .default,
    CookieLaw,
  },
  mixins: [users],
  data: function () {
    return {
      loader: null,
      loaderCounter: { enable: 0, disable: 0 },
      showNavBar: true,
      showNavBarWhenHover: true,
      dashScreenIcons: {
        account: "",
        apps: "",
        dashscreen: "",
        financial: "",
        emails: "",
        billPayment: "",
        readings: "",
        attachments: "",
      },

      bShowSecurities: true,
      bExistPdfManual: false,
      bAllowDashboards: false,
      showDashboardsOnStartScreen: false,
      portalName: "Edams",
      returnUrl: "",
      returnUrlText: "",
      pageTitle: "",
      unreadMsgCount: 0,
      messagesData: null,
      msgTimer: null,
      googleMapsApiKey: "",
      settings: {
        logo: null,
        orgName: "",
        orgShortName: "",
        paymentLink: "",
        brandingColor: "",
        brandingSecondaryColor: "",
        brandingAccentColor: "",
      },
      jcc: {
        applicationId: 0,
        typeId: 0,
      },
      oidcModel: {
        account: "",
        idNo: "",
        email: "",
        name: "",
        surname: "",
        cellTelNo: "",
      },
      languages: [],
      renderKey: 0,
      brandPrimaryColor: "",
      brandSecondarytColor: "",
      brandAccentColor: "",
      brandingLoginPrimaryColor: "",
      brandingLoginSecondaryColor: "",
      showSidepanel: false,
      showNavigationDrawer: false,
      bShowUnreadMessages: false,
      bShowWarning: false,
      currencySymbol: "€",
      defaultLanguage: "en",
      bSelectAccount: true,
      bShowElementExternalRef: false,
      bShowElementLogDescription: true,
      bShowElementLogExternalRef: false,
      bShowElementUserRef: true,
      bShowTermsAndConditions: false,
      bValidateCustomerAccountEmail: true,
      bValidateCustomerAccountIdNo: true,
      bValidateCustomerAccountMobileNo: false,
      bCustomerMeterReadings: true,
      bLoginOtp: false,
      menuItems: [],
      portalAuthenticationType: 0,
      profileStatus: -1,
      bIsCustomerApplications: false,
      bIsCustomerBillingPortal: false,
      videoLinkString: "",
      videoLinks: [],
      loginStyleClass: true,
      loginBgImage: "",
      homeButtonUrl: "",
      //puts props here
      payBillButtonUrl: null,
    };
  },
  props: {
    bgColor: {
      type: String,
      default: "#0C3C60",
    },
    //,height: {
    //  type: Number,
    //  default: 100
    //}
  },
  computed: {
    userMenu: function () {
      return utils.getMenuItems(this.user, this.roles);
    },
    brandingColor() {
      return {
        "background-color": `${this.settings.brandingColor} !important`,
      };
    },
    brandingSecondaryColor() {
      return {
        "background-color": `${this.settings.brandingSecondaryColor} !important`,
      };
    },
    brandingSecondaryColorText() {
      return { color: `${this.settings.brandingSecondaryColor} !important` };
    },
    brandingAccentColor() {
      return { color: `${this.settings.brandingAccentColor} !important` };
    },
    langSrc: function (langId) {
      return "/static/images/" + langId + ".png";
    },
    displayNavigationBar: function () {
      let missingImageFlag = false;
      this.menuItems.forEach((m) => {
        if (m.image == null || m.image.length < 21) missingImageFlag = true;
      });

      return !missingImageFlag;
    },
    enableHoveredArea: function () {
      if (this.showNavBarWhenHover == true && this.showNavBar == true)
        return "hover-area";
      else return "";
    },
    showNavigationBar: function () {
      if (this.showNavBarWhenHover == true && this.showNavBar == true)
        return "hide stay-when-hovered";
      else if (this.showNavBar == true) return "stay-when-hovered";
      else return "hide";
    },
    portalProfileType: function () {
      let sett = this.$store.getters.getProfileDetails;

      if (sett) return sett.registrationType ?? 1;

      return 1;
    },
  },
  watch: {
    showNavigationDrawer: function (value) {
      if (value === true && this.menuItems.length === 0) {
        this.getProfileDetails();
      }
    },
    userAuthenticated: function (value) {
      if (value) {
        this.getOrganisationSettings();

        if (this.user.role == this.roles.Customer) {
          setTimeout(() => {
            this.getUnreadMsgCount();
          }, 3000);
          this.msgTimer = setInterval(() => {
            this.getUnreadMsgCount();
          }, 60000);
        }
      } else {
        if (this.msgTimer != null) clearInterval(this.msgTimer);
      }
    },
    $route(to, from) {
      if (to.name == "login") this.loginStyleClass = true;
      else this.loginStyleClass = false;
    },
  },
  async created() {
    if (
      !this.$store.getters.getSelectedAccount.account &&
      !window.location.href.includes("app") &&
      !window.location.pathname.includes("customerEvaluation")
    ) {
      this.$router.push("userHome");
    }

    await this.init();
  },
  methods: {
    async init() {
      this.$root.$on("get_profile_details", this.getProfileDetails);
      this.$root.$on("enable_disable_loader", (enabled, props) =>
        this.enableDisableLoader(enabled, props)
      );

      await this.getOrganisationSettings();
      await this.getSettings();
      await this.getProfileDetails();

      this.getVideoLink();

      this.$router.beforeEach((to, from, next) => {
        this.loginStyleClass = false;

        if (this.$t)
          this.pageTitle =
            this.portalName + " - " + this.$t("routes." + to.name);

        //console.log(to.name);
        //console.log(from.name);
        if (to.name === "confirmLink" && from.name === "confirmLink")
          to.params = from.params;
        else if (from.name === "changeEmailComplete") to.params = from.params;
        else if (to.name === "resetPassword" && from.name === "resetPassword")
          to.params.code = from.params.code;
        else if (
          to.meta.requiresAuth &&
          (!this.user || !this.user.authenticated)
        ) {
          this.loginStyleClass = true;
          next("/login");
        } else if (
          to.name === "login" &&
          this.user &&
          this.user.authenticated
        ) {
          next("/userHome");
        } else next();
      });

      //this.$router.beforeEach((to, from, next) => {

      //  if (this.$t)
      //    this.pageTitle = this.portalName + ' - ' + this.$t('routes.' + to.name);

      //  if (to.name === 'confirmLink' && from.name === 'confirmLink')
      //    to.params = from.params;
      //  if (to.name === 'resetPassword' && from.name === 'resetPassword')
      //    to.params.code = from.params.code;
      //  else if (to.meta.requiresAuth && (!this.user || !this.user.authenticated))
      //    next('/login');
      //  else if (to.name === 'login' && this.user && this.user.authenticated) {
      //    next('/userHome');
      //  }
      //  else
      //    next();

      //});

      this.$root.$on("user_loggedin", this.login);

      this.existPdfManual();

      this.getReturnUrl();

      if (!this.userAuthenticated) this.getUserDetails();

      this.initNotifierGlobalOptions();
    },
    disableLoginButton(date) {
      this.$store.commit("setDisableLoginButtonDate", date);
      this.$store.commit(
        "setDisableLoginButtonDescription",
        `${this.$t("common.LoginDisabled")} ${moment(date)
          .locale(this.$i18n.locale)
          .format("Do MMMM ")}`
      );

      axios
        .post("/Utility/GetMessage", { Lang: this.$i18n.locale, TextId: 112 })
        .then((response) => {
          if (response.data.data.status == 0)
            this.$store.commit(
              "setDisableLoginButtonText",
              response.data.settings.text ?? null
            );
        });
    },
    enableDisableLoader(enabled = true, props) {
      if (enabled) this.loaderCounter.enable++;

      if (!enabled) this.loaderCounter.disable++;

      //console.log("enable:", this.loaderCounter.enable, "  --  diasble:", this.loaderCounter.disable)
      if (
        this.loader &&
        this.loaderCounter.disable != this.loaderCounter.enable
      )
        return;

      if (!props)
        props = {
          color: "#23348d",
          loader: "dots",
          width: 256,
          height: 256,
          backgroundColor: "#ffffff",
          opacity: 0.5,
        };

      if (enabled) this.loader = this.$loading.show(props);
      else {
        if (this.loader && this.loader.isActive) this.loader.hide();
        this.loaderCounter.disable = 0;
        this.loaderCounter.enable = 0;
        this.loader = null;
      }

      this.$forceUpdate();
    },
    goToOrgWebpage() {
      if (this.homeButtonUrl != "") window.location.href = this.homeButtonUrl;
      else this.$router.push("/userHome");
    },
    navigateToPage(page) {
      if (page == "readings") page = "app/" + page;

      if (page == "apps") page = "app/0/0";

      this.$router.push("/" + page);
    },
    initNotifierGlobalOptions() {
      let globalOptions = {
        position:
          this.$localStorage.get("_lang") == "ar"
            ? "bottom-left"
            : "bottom-right",
        labels: {
          tip: this.$t("notifications.labels.tip"),
          info: this.$t("notifications.labels.info"),
          success: this.$t("notifications.labels.success"),
          warning: this.$t("notifications.labels.warning"),
          alert: this.$t("notifications.labels.alert"),
          async: this.$t("notifications.labels.async"),
          confirm: this.$t("notifications.labels.confirm"),
          confirmOk: this.$t("notifications.labels.confirmOk"),
          confirmCancel: this.$t("notifications.labels.confirmCancel"),
        },
      };

      this.$store.commit("initNotifier", { options: globalOptions });
    },
    getVideoLink() {
      var parameter = {
        Lang: this.$i18n.locale,
        TextId: 51,
      };
      axios.post("/Utility/GetMessage", parameter).then((response) => {
        if (response.data.data.status == 0) {
          this.videoLinkString = response.data.settings.text; // 'https://www.youtube.com/watch?v=Atuirnd0MzQ;https://www.youtube.com/watch?v=2GvREvuWaZI';
          if (this.videoLinkString.length > 0) {
            this.videoLinks = [];
            let entries = this.videoLinkString.split(";");
            entries.forEach((item) => {
              var itemArray = item.split("||");
              var videoLink = {
                title: itemArray[0],
                url: itemArray[1],
              };
              this.videoLinks.push(videoLink);
            });
          }
        }
      });
    },
    visitMainSite() {
      window.location.href = this.returnUrl;
    },
    goToVideoLink(lnk) {
      window.open(lnk, "_blank");
    },
    getReturnUrl() {
      axios
        .post("/Utility/GetMessage", { Lang: this.$i18n.locale, TextId: 47 })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.returnUrlText =
              response.data.settings.text &&
              response.data.settings.text.length > 0
                ? response.data.settings.text
                : "Return to main site";
          }
        });
      axios
        .post("/Utility/GetMessage", { Lang: this.$i18n.locale, TextId: 48 })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.returnUrl = response.data.settings.text;
          }
        });
    },
    getCopyrightMessage() {
      var year = new Date();
      return "Copyright Hydro-Comp Enterprises Ltd, " + year.getFullYear();
    },
    getProfileStatus() {
      axios.post("/account/GetProfileStatus").then((response) => {
        if (response.data.data.status == 0) {
          this.profileStatus = response.data.status;
          if (this.profileStatus === 0) this.loginOidc();
          else if (this.profileStatus === 2) this.getOidcAriadniAccount();
          else {
            //if (this.profileStatus === 1)
            var userEmail = response.data.userEmail;

            if (userEmail && userEmail.length > 0) {
              this.$localStorage.set("_login", userEmail);
              this.$root.$emit("user_loggedin");
              if (this.$router.currentRoute.name !== "export")
                this.$router.push("/apps");
            }
          }
        }
      });
    },
    existPdfManual() {
      axios
        .post("/Utility/IsExistingLocalizedFile", { Value: 1 })
        .then((response) => {
          if (response.data.data.status === 0) {
            this.bExistPdfManual = response.data.isExisting;
          } else this.showMessage(response.data.data.text, 1);
        })
        .catch((e) => {
          return false;
        });
    },
    getPdfManual() {
      axios
        .post("/Utility/IsExistingLocalizedFile", { Value: 1 })
        .then((response) => {
          if (
            response.data.data.status === 0 &&
            response.data.isExisting === true
          ) {
            this.download(1);
          } else if (
            response.data.data.status === 0 &&
            response.data.isExisting === false
          ) {
            this.bShowWarning = true;
          } else {
            this.showMessage(response.data.data.text, 1);
          }
        })
        .catch((e) => {
          return false;
        });
    },
    download(id) {
      this.enableDisableLoader(true);

      axios
        .post(
          "/Utility/DownloadLocalizedFile",
          { Value: id },
          { responseType: "blob" }
        )
        .then(files.getFile)
        .then((link) => {
          link.click();
        })
        //.then(response => { files.getFile(response) })
        //.then(response => {
        //  this.enableDisableLoader(false);
        //})
        .catch((err) => {
          this.enableDisableLoader(false);
          console.log(err);
        })
        .finally(this.enableDisableLoader(false));
    },
    startTourGuide() {
      if (this.$tours["portalTour"]) this.$tours["portalTour"].start();
    },
    getLangImage(langCode) {
      var sImgUrl = "/static/images/" + langCode + ".png";
      return sImgUrl;
    },
    getHelpImage(sImg) {
      var sImgUrl = "/static/images/" + sImg + ".png";
      return sImgUrl;
    },
    async getProfileDetails() {
      return await axios
        .post("/account/GetProfileDetails")
        .then((response) => {
          if (response.data.data.status == 0) {
            //add flag for field worker user
            this.user["isFieldWorker"] = response.data.item.isFieldWorker;

            this.$store.commit("setProfileDetails", response.data.item);

            //check if property oriented
            propCheck(
              this.$store,
              this.$localStorage,
              response.data.item.account
            );

            var resp = response.data.item;
            this.portalNewCs =
              resp.portalNewCs && resp.portalNewCs == true ? true : false;
            this.portalOm =
              resp.portalOm && resp.portalOm == true ? true : false;
            this.portalDisconnections =
              resp.portalDisconnections && resp.portalDisconnections == true
                ? true
                : false;
            this.portalDm =
              resp.portalDm && resp.portalDm == true ? true : false;
            this.portalElements =
              resp.elementProperties && resp.elementProperties == true
                ? true
                : false;
            this.portalAssetRegister =
              resp.assetRegister && resp.assetRegister == true ? true : false;
            this.portalLogs =
              resp.portalLogs && resp.portalLogs == true ? true : false;
            this.portalQuality =
              resp.portalQuality && resp.portalQuality == true ? true : false;
            this.portalCaptureMeterReadings =
              resp.portalCaptureMeterReadings &&
              resp.portalCaptureMeterReadings == true
                ? true
                : false;
            this.portalGis =
              resp.portalGis && resp.portalGis == true ? true : false;
            this.portalGisAdmin =
              resp.portalGisAdmin && resp.portalGisAdmin == true ? true : false;
            this.showContactUsPage =
              resp.showContactUsEmail ||
              (resp.contactUsUrl && resp.contactUsUrl.length > 0)
                ? true
                : false;
            this.portalEnquiries = false;

            var user = { role: resp.role, authenticated: true };

            let menuItems = utils.getMenuItems(user, this.roles);

            this.menuItems = this.payBillButtonUrl
              ? menuItems.filter((m) => m.id != "billPayment")
              : menuItems;

            this.menuItems.shift();

            //if (this.showDashboardsOnStartScreen === true) {
            //  this.menuItems = this.menuItems.filter(item => item.id != 'dashscreen');
            //}
            if (this.bAllowDashboards === false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "dashscreen"
              );
            }

            if (this.bCustomerMeterReadings === false)
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "readings"
              );

            if (this.portalNewCs == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "applications"
              );
            }
            if (this.portalOm == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "omApplications"
              );
            }
            if (this.portalDisconnections == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "disconnections"
              );
            }
            if (this.portalDm == false) {
              this.menuItems = this.menuItems.filter((item) => item.id != "dm");
            }
            if (this.portalElements == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "elements"
              );
            }
            if (this.portalAssetRegister == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "assets"
              );
            }
            if (this.portalLogs == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "logs"
              );
            }
            if (this.portalQuality == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "samples"
              );
            }
            if (this.portalCaptureMeterReadings == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "captureMeterReadings"
              );
            }
            if (this.portalGis == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "webgis"
              );
            }
            if (this.portalGisAdmin == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "gisAdministration"
              );
            }
            if (this.showContactUsPage == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "contactUs"
              );
            }

            var link = this.settings.paymentLink;
            if (!link || link === "") {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "billPayment"
              );
            }

            this.menuItems.forEach((m) => {
              m["image"] = this.dashScreenIcons[m.id];
            });

            return true;
          } else {
            this.$parent.user.authenticated = false;
            this.loginStyleClass = true;
            this.$router.push("/login");
            return false;
          }
        })
        .catch((e) => {
          //console.log("error GetProfileDetails", e)
          if (this.$parent && this.$parent.user)
            this.$parent.user.authenticated = false;

          return false;
        });
    },
    open(ref) {},
    close(ref) {},
    logout() {
      axios
        .post("/account/Logout")
        .then((response) => {
          this.user.authenticated = false;
          this.$localStorage.set("_login", null);
          this.$localStorage.set("_preference", null);
          this.$localStorage.set("_property", null);
          this.resetUserDetails();
          this.$router.push("/login");
          this.loginStyleClass = true;
        })
        .catch((e) => {});
    },
    login(event) {
      if (event) event.preventDefault();
      this.getUserDetails();
    },
    getUnreadMsgCount() {
      if (this.user && this.user.authenticated) {
        axios
          .post("/ApplicationMessage/GetUnreadItemsCount")
          .then((response) => {
            if (response.data.data.status == 0) {
              this.unreadMsgCount = response.data.count;
            }
          })
          .catch((e) => {});
      } else this.unreadMsgCount = 0;
    },
    showUnreadMessages() {
      this.bShowUnreadMessages = true;
      this.messagesData = {
        appId: -1,
        mimeTypes:
          "image/png,image/jpeg,application/pdf,application/msword,application/excel",
        multiple: false,
        permissions: { add: false },
        bShowEdit: false,
      };
      Vue.nextTick(
        function () {
          this.$root.$emit("unread_messages_updated");
        }.bind(this)
      );
    },
    closeDialog() {
      this.messagesData = null;
      this.bShowUnreadMessages = false;
      this.getUnreadMsgCount();
    },
    setLang(lang, reloadPage = false) {
      this.$localStorage.set("_lang", lang);
      this.$i18n.locale = lang;
      this.setLanguage(lang, reloadPage);

      if (
        this.$store.getDisableLoginButton &&
        this.$store.getDisableLoginButton.date
      )
        this.disableLoginButton(this.$store.getDisableLoginButton.date);

      this.$root.$emit("lang_changed");
    },
    async getOrganisationSettings() {
      return await axios
        .post("/Utility/GetOrganisationSettings")
        .then((response) => {
          if (response.data.data.status == 0) {
            this.payBillButtonUrl = response.data.settings.payBillDashboardLink;

            this.settings = response.data.settings;
            let temp = { ...this.settings };

            delete temp.logo;
            delete temp.applicationsIcon;
            delete temp.attachmentsIcon;
            delete temp.billPaymentIcon;
            delete temp.dashScreenIcon;
            delete temp.emailsIcon;
            delete temp.transactionsIcon;
            delete temp.accountIcon;
            delete temp.meterReadingsIcon;
            delete temp.loginBackgroundImage;

            this.disableLoginButton(this.settings.disableLoginDate);

            this.$localStorage.set("orgSettings", JSON.stringify(temp));
            this.$store.commit("setOrgSettings", temp);

            this.settings.orgName =
              this.$t("HomeHome") + " - " + this.settings.orgName;
            this.brandPrimaryColor = this.settings.brandingColor;
            this.brandSecondaryColor = this.settings.brandingSecondaryColor;
            this.brandingLoginPrimaryColor =
              this.settings.brandingLoginPrimaryColor;
            this.brandingLoginSecondaryColor =
              this.settings.brandingLoginSecondaryColor;
            this.brandAccentColor = this.settings.brandingAccentColor;

            this.$localStorage.set(
              "brandingColor",
              this.settings.brandingColor
            );
            this.$localStorage.set(
              "brandingSecondaryColor",
              this.settings.brandingSecondaryColor
            );
            this.$localStorage.set(
              "brandingAccentColor",
              this.settings.brandingAccentColor
            );
            this.$localStorage.set(
              "brandingLoginPrimaryColor",
              this.settings.brandingLoginPrimaryColor
            );
            this.$localStorage.set(
              "brandingLoginSecondaryColor",
              this.settings.brandingLoginSecondaryColor
            );

            this.showNavBar = response.data.settings.enableIconsNavBar;
            this.showNavBarWhenHover = response.data.settings.showNavBarOnHover;

            this.dashScreenIcons = {
              account: response.data.settings.accountIcon,
              apps: response.data.settings.applicationsIcon,
              dashscreen: response.data.settings.dashScreenIcon,
              financial: response.data.settings.transactionsIcon,
              emails: response.data.settings.emailsIcon,
              billPayment: response.data.settings.billPaymentIcon,
              readings: response.data.settings.meterReadingsIcon,
              attachments: response.data.settings.attachmentsIcon,
            };

            if (this.user.authenticated == true) this.getProfileDetails();

            this.loginBgImage = response.data.settings.loginBackgroundImage;
            return false;
          }

          return true;
        })
        .catch((err) => {
          return false;
        });
    },
    async getSettings() {
      return await this.$store
        .dispatch("getUtilitySettings")
        .then((response) => {
          //console.log("resp", response)
          if (response.isValid) {
            this.languages = response.languages;
            this.bCustomerMeterReadings = response.customerMeterReadings;
            this.portalName = response.portalName;
            this.pageTitle = this.portalName;

            this.currencySymbol = response.currencySymbol;
            this.defaultLanguage = response.defaultLanguage;
            this.bSelectAccount = response.isSelectAccount;

            this.bValidateCustomerAccountEmail =
              response.isValidateCustomerAccountEmail;
            this.bValidateCustomerAccountIdNo =
              response.isValidateCustomerAccountIdNo;
            this.bValidateCustomerAccountMobileNo =
              response.isValidateCustomerAccountMobileNo;

            this.portalAuthenticationType = response.portalAuthenticationType;
            this.bIsCustomerApplications = response.isCustomerApplications;
            this.bIsCustomerBillingPortal = response.isCustomerBillingPortal;

            this.bAllowDashboards = response.allowDashboardsCustomer;
            this.showDashboardsOnStartScreen =
              response.showDashboardsOnStartScreen;

            this.bLoginOtp = response.customerLoginWithOtp;

            this.googleMapsApiKey = response.googleMapsAPIKey;
            if (this.googleMapsApiKey.length === 0)
              this.googleMapsApiKey = "AIzaSyDrc9okYRYhkWwAeavICKZdDKqcTyZ8TUo";

            this.homeButtonUrl = response.homeButtonUrl;

            Vue.use(VueGoogleMaps, {
              load: {
                key: this.googleMapsApiKey,
                libraries: "places,drawing,visualization,geometry",
              },
              installComponents: true,
            });

            var lang = this.$localStorage.get("_lang");

            this.$store.commit("setSettings", response);
            //TBI

            if (lang && lang.length > 0) this.setLanguage(lang);
            else this.setLang(this.defaultLanguage);

            return true;
          } else {
            this.$router.push("/login");
            return false;
          }
        });
    },
    setLanguage(locale, reloadPage) {
      const parameters = {
        LanguageCode: locale,
        UpdateProfile: true,
      };

      axios.post("/Utility/SetLanguage", parameters).finally(() => {
        if (reloadPage == true) location.reload();
      });
    },
    payBill() {
      var link = this.settings.paymentLink; // 'https://www.jccsmart.com/e-bill/11853017'
      if (link && link != "") window.open(link, "_blank");
    },
    getBackgroundImageStyle() {
      let res = "";

      if (this.loginBgImage != "" && this.loginStyleClass) {
        res = "backgroundImage: url(" + this.loginBgImage + ")";
      }

      return res;
    },
  },
};
